import type { ReactElement } from 'react';
import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import { AnswerSource } from 'src/redux/survey/survey.types';
import type { SourceFilterOption } from '../../services/source-filter.helpers';

interface SourceFilterControlProps {
  sourceFilter: AnswerSource;
  options: SourceFilterOption[];
  onSourceFilterChange: (source: AnswerSource) => void;
}

function SourceFilterControl({
  sourceFilter,
  options,
  onSourceFilterChange,
}: SourceFilterControlProps): ReactElement | null {
  if (options.length <= 1) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap items-center gap-3"
      role="group"
      aria-label="Response source filter"
    >
      <span className={portalDs.filterLabel}>
        Responses from
      </span>
      <div className={portalDs.segmentGroup}>
        {options.map((option) => (
          <button
            key={option.paramValue}
            type="button"
            className={cn(
              portalDs.segment,
              sourceFilter === option.value && portalDs.segmentActive,
            )}
            onClick={() => onSourceFilterChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SourceFilterControl;
